// this mixin provides update and remove methods for trainings based on uuid from url
import notification from '../../notification'

export default {
  data () {
    return {
      training: null,
      disabledForm: true,
    }
  },
  mounted () {
    this.getTraining()
  },
  methods: {
    getTraining () {
      this.$vs.loading()
      const payload = this.$route.params.uuid
      this.$store.dispatch('trainings/getTraining', payload)
        .then((response) => {
          this.training = response.data.data
          this.getAllowedPositionsState()
          this.training.thumbnail = null
        })
        .catch(error => {
          this.$vs.notify(notification.error(error.message))
        })
        .finally(() => {
          this.$vs.loading.close()
        })
    },
    toggleFormEdit () {
      if (!this.disabledForm) {
        this.getTraining()
      }
      this.formErrors = {}
      this.disabledForm = !this.disabledForm
    },
    deleteTraining () {
      this.$vs.loading()
      const payload = this.$route.params.uuid
      this.$store.dispatch('trainings/deleteTraining', payload)
        .then(() => {
          this.$router.go(-1)
          this.$vs.notify(notification.success('Szkolenie zostało usunięte'))
        })
        .catch(error => {
          this.$vs.notify(notification.error(error.message))
        })
        .finally(() => {
          this.$vs.loading.close()
        })
    },
    updateTraining () {
      this.$vs.loading()
      const formData = new FormData()
      formData.append('name', this.training.name)
      formData.append('description', this.training.description)
      if(this.training.thumbnail)
      formData.append('thumbnail', this.training.thumbnail)
      formData.append('_method',  "PATCH")
      for (let i = 0; i < this.allowedUserPositionList.length; i++) {
        formData.append('allowed_user_positions[]', this.allowedUserPositionList[i])
      }
      const payload = {
        trainingFormData: formData,
        uuid: this.$route.params.uuid
      }
      this.$store.dispatch('trainings/updateTraining', payload)
        .then((response) => {
          this.$vs.notify(notification.success('Szkolenie zostało dodane'))
          this.getTraining()
          this.disabledForm = true
        })
        .catch(error => {
            if (error.response && error.response.status === 422) {
              this.formErrors =  error.response.data.errors
            } else {
              this.$vs.notify(notification.error(error.message))
            }
        })
        .finally(() => {
          this.$vs.loading.close()
        })
    },
    getAllowedPositionsState() {
      if(this.employmentPositionItems  && this.training.allowed_user_positions){
        this.employmentPositionItems.map (i => {
          if(this.training.allowed_user_positions.find(l=> l === i.value))
            i.state = true
          else
            i.state=false
        })
      }
    },
  }
}
